import { validator } from "@/utils/validator";

export type TUserLoginVerifyForm = {
  email: string;
  code: string;
};

export const userLoginVerifySchema = validator.object().shape({
  email: validator.string().emptyToNull().autoTransformToHalfWidth().label("メールアドレス").required(),
  code: validator.string().emptyToNull().autoTransformToHalfWidth().label("認証コード").required(),
});
